function initProductCardSliders() {

  document.querySelectorAll(".product-card-slider").forEach((slider) => {

    if (slider.dataset.initialized === "true") return;
    slider.dataset.initialized = "true";

    const img = slider.querySelector(".product-card-main-image");
    const json = slider.querySelector(".product-card-images-json");

    if (!img || !json) return;

    let images;

    try {
      images = JSON.parse(json.textContent);
    } catch (e) {
      console.error("Invalid product image JSON", e);
      return;
    }

    if (!images.length) return;

    let current = 0;

    slider.dataset.current = 0;

    // preload
    images.forEach((image) => {
      const preload = new Image();
      preload.src = image.src;
    });

    function swap(index) {

      if (index < 0) index = images.length - 1;
      if (index >= images.length) index = 0;

      current = index;
      slider.dataset.current = current;

      img.classList.add("is-fading");

      setTimeout(() => {

        img.src = images[current].src;
        img.alt = images[current].alt || "";

        requestAnimationFrame(() => {
          img.classList.remove("is-fading");
        });

      }, 90);

    }

    slider.addEventListener("mouseenter", () => {
      if (images.length > 1 && current === 0) {
        swap(1);
      }
    });

    slider.addEventListener("mouseleave", () => {
      swap(0);
    });

    slider.querySelector(".product-card-arrow--next")?.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      swap(current + 1);
    });

    slider.querySelector(".product-card-arrow--prev")?.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      swap(current - 1);
    });

    slider.addEventListener("click", (e) => {

      if (e.target.closest(".product-card-arrow")) return;

      const url = slider.dataset.productUrl;

      if (url) {
        window.location.href = url;
      }

    });

  });

}

// Initial page load
document.addEventListener("DOMContentLoaded", initProductCardSliders);

// Re-initialize if Shopify injects new product cards
const observer = new MutationObserver(() => {
  initProductCardSliders();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});